export const endpoints = {
  auth: {
    login: "/auth/login",
    register: "/auth/register",
    forgot: "/auth/forgot",
    reset: "/auth/reset",
    me: "/auth/me",
  },
  landing: {
    metrics: "/landing/metrics",
  },
};
